import React,{Component} from "react";
import First from './First/First'
import Second from './Second/Second'

class Modallog extends Component {

             
    render(){
      return (
        <div>
      {this.props.fs?<First closed={this.props.closedModal} modalHandler={this.props.modalHandler} type={this.props.type} show={this.props.show}/> : 
      <Second closedModal={this.props.closedModal} show={this.props.show} />} 
       </div>
      );
    }
};

export default Modallog;
